import apiClient from '../api/client/apiClient';
import { PaginatedResponse } from '@/models';
import { PathwayEpisode } from '@/models/pathway-episodes.model';

// eslint-disable-next-line vue/max-len
export function getEpisodes(organisation, patient, params = {}): Promise<PaginatedResponse<PathwayEpisode[]>> {
  return apiClient.get(`v1/organisations/${organisation}/patients/${patient}/pathways`, { params });
}
